<template>
  <router-view />
</template>

<script>
export default {
  name: 'App',
  watch: {
    $route() {
      document.title = this.$route.meta.title || 'Game'
    }
  },
  mounted() {
    document.title = this.$route.meta.title || 'Game'
  }
}
</script>

<style lang="scss">
#app {
  height: 100%;
}
</style>
